class URLConverterService {
    static stringify = (filters, page) => {
        const parts = [];

        Object.keys(filters).forEach((key) => {
            const value = filters[key];

            if (value !== "") {
                parts.push(`${key}:${filters[key]}`);
            }
        });

        parts.push(`pagina:${page}`);

        return parts.join('/') || '';
    };

    static parse = (string) => {
        const parts = string.split('/');
        const object = {
            filters: {},
            page: 1,
        };

        parts.forEach((part) => {
            if (part !== "") {
                const key = part.split(':')[0];
                const value = part.split(':')[1];

                if (key === "pagina") {
                    object.page = value;
                } else {
                    object.filters[key] = value;
                }
            }
        });

        return object;
    };
};

export default URLConverterService;
